import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/login.vue";

const routerList = [];

function importAll(r) {
  r.keys().forEach((key) => routerList.push(...r(key).default));
}
//载入所有路由文件
importAll(
  require.context(
    "../../packages/cc_merchant_sis/routers",
    true,
    /\.routes\.js/
  )
);

Vue.use(VueRouter);

const routes = [
  //   {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  // },
  {
    path: "/login/v2",
    name: "Login",
    component: Login,
  },
  ...routerList,
];
console.log(routerList);
const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
